import React, { useState } from "react";
import { initGA } from "./utils/analytics";

const STORAGE_KEY = "cookie_consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(STORAGE_KEY));

  if (!visible) return null;

  const handle = (value) => {
    localStorage.setItem(STORAGE_KEY, value);
    if (value === "accepted") initGA();
    setVisible(false);
  };

  return (
    <div style={{
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: "#1a1a2e",
      color: "#e0e0e0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "16px",
      padding: "12px 24px",
      fontSize: "13px",
      boxShadow: "0 -2px 8px rgba(0,0,0,0.3)",
      flexWrap: "wrap",
    }}>
      <span>
        We use cookies for analytics to improve your experience.
      </span>
      <div style={{ display: "flex", gap: "8px" }}>
        <button
          onClick={() => handle("accepted")}
          style={{
            background: "#4f46e5",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            padding: "6px 18px",
            cursor: "pointer",
            fontSize: "13px",
            fontWeight: 600,
          }}
        >
          Accept
        </button>
        <button
          onClick={() => handle("rejected")}
          style={{
            background: "transparent",
            color: "#aaa",
            border: "1px solid #444",
            borderRadius: "6px",
            padding: "6px 18px",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          Reject
        </button>
      </div>
    </div>
  );
}
